import http from "./httpService";

export async function initiatePayment(paymentEndPoint, data) {
  let result = null;
  try {
    console.log(
      "initiatePayment: data.revenueCode: " +
        data.revenueCode +
        ",data.amount: " +
        data.feeValue * 100 +
        ", data.custRef: " +
        data.custRef +
        ", data.fullName: " +
        data.fullName
    );

    var paymentDetails = {
      revenueCode: data.revenueCode,
      amount: data.feeValue * 100, //data.amount*100,
      custRef: data.custRef,
      fullName: data.fullName
    };

    result = await http.post(paymentEndPoint + "/initiatePayment", paymentDetails);

  } catch (ex) {
    console.log("initiatePayment.error: " + ex);
    return ex.response;
  }

  return result;
}

export async function makePayment(paymentEndPoint, data) {
  let result = null;
  try {
    console.log(
      "makePayment: data.orderId: " +
        data.orderId +
        ",data.amount: " +
        data.feeValue * 100 +
        ",data.merchantCode: " +
        data.merchant_code
    );

    var paymentDetails = {
      orderId: data.orderId,
      amount: data.feeValue * 100,
      merchantCode: data.merchant_code
    };
    result = await http.post(paymentEndPoint + "/makePayment", paymentDetails);
  } catch (ex) {
    console.log("makePayment.error: " + ex);
  }

  return result;
}

export async function sendPaymentRequest(paymentEndPoint, data, obj) {
  var result = null;

  try {
    console.log(
      "sendPaymentRequest: data.PayerPhoneNumber: " +
        data.PayerPhoneNumber +
        ",obj.feeValue: " +
        obj.feeValue +
        ",obj.propertyNumber: " +
        obj.propertyNumber +
        ",obj.OwnerId: " +
        obj.OwnerId +
        ",obj.WebUserId: " +
        obj.WebUserId
    );

    var paymentDetails = {
      PayerPhoneNumber: data.PayerPhoneNumber,
      PaymentAmount: obj.feeValue,
      PaymentCurrency: "EUR",
      PropertyNumber: obj.propertyNumber,
      IsZilmisUser: obj.OwnerId ? (obj.OwnerId > 0 ? "true" : "false") : "false",
      WebUserId: obj.WebUserId > 0 ? obj.WebUserId : null,
      OwnerId: obj.OwnerId > 0 ? obj.OwnerId : null,
      PaymentMethod: "MOMO",
    };
    result = await http.post(paymentEndPoint + "/requesttopay", paymentDetails);
  } catch (ex) {
    console.log("sendDNPaymentRequest.error: " + ex);
  }

  return result;
}

export function sendClickLog(paymentEndPoint, LandId, IDType, IDNumber, FullName)
{
  console.log("Sending click log to:", `${paymentEndPoint}/logs/button-click`);
 fetch(`${paymentEndPoint}/logs/button-click`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      buttonId: 'pay-button-from-stage-3',
      landId: LandId,
      idType: IDType,
      idNumber: IDNumber,
      fullName: FullName,
      timestamp: new Date().toISOString()
    }),
  }).catch(err => {
    console.error("Failed to log button click", err);
  });
}

export function sendLog(paymentEndPoint, LandId, IDType, IDNumber, FullName, LogContent)
{
  console.log("Sending log to:", `${paymentEndPoint}/general-log`);
 fetch(`${paymentEndPoint}/general-log`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      landId: LandId,
      idType: IDType,
      idNumber: IDNumber,
      fullName: FullName,
      logContent: LogContent,
      timestamp: new Date().toISOString()
    }),
  }).catch(err => {
    console.error("Failed to log", err);
  });
}

export async function sendDNPaymentRequest(paymentEndPoint, data, obj) {
  var result = null;

  console.log(
    "sendDNPaymentRequest: data.PayerPhoneNumber: " +
      data.PayerPhoneNumber +
      ",obj.feeValue: " +
      obj.feeValue +
      ",obj.propertyName: " +
      obj.propertyName +
      ",data.DemandNoticeNumber: " +
      data.DemandNoticeNumber +
      ",obj.OwnerId: " +
      obj.OwnerId +
      ",obj.WebUserId: " +
      obj.WebUserId +
      ",data.IsZilmisUser: " +
      data.IsZilmisUser
  );

  var paymentDetails = {
    PayerPhoneNumber: data.PayerPhoneNumber,
    PaymentAmount: obj.feeValue,
    PaymentCurrency: "EUR",
    PropertyNumber: obj.propertyName,
    DemandNoticeNumber: data.DemandNoticeNumber,
    IsZilmisUser: data.IsZilmisUser,
    WebUserId: obj.WebUserId > 0 ? obj.WebUserId : null,
    OwnerId: obj.OwnerId > 0 ? obj.OwnerId : null,
    PaymentMethod: "MOMO"
  };
  try {
    result = await http.post(
      paymentEndPoint + "/requesttopaydemandnotice",
      paymentDetails
    );
  } catch (ex) {
    console.log("sendDNPaymentRequest.error: " + ex);
  }
  return result;
}
